var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 19,
    fill: "#96CD00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1048 20.2196C19.9197 20.83 21.0555 20.652 21.6481 19.8128L23.7716 16.7867C24.3642 15.9476 24.1914 14.7778 23.3766 14.1675C22.5617 13.5573 21.4259 13.7353 20.8333 14.5744L18.685 17.6005C18.1171 18.4396 18.29 19.6094 19.1048 20.2196ZM28.8335 15.9476C28.0186 15.3373 26.8828 15.5153 26.2902 16.3544L17.7467 28.4586C17.1541 29.2978 17.327 30.4675 18.1418 31.0778C18.9566 31.6881 20.0925 31.5101 20.6851 30.671L29.2285 18.5668C29.8458 17.7276 29.6483 16.5579 28.8335 15.9476ZM18.29 14.9813C18.8826 14.1421 18.7097 12.9724 17.8949 12.3621C17.0801 11.7518 15.9442 11.9298 15.3516 12.769C14.759 13.6081 14.9318 14.7779 15.7467 15.3882C16.5615 15.9985 17.6974 15.8204 18.29 14.9813ZM31.2533 31.6118C30.4385 31.0015 29.3027 31.1796 28.71 32.0187C28.1174 32.8579 28.2902 34.0276 29.1051 34.6379C29.92 35.2482 31.0558 35.0702 31.6484 34.231C32.241 33.3919 32.0681 32.2221 31.2533 31.6118ZM27.9199 26.8057C27.1051 26.1955 25.9693 26.3735 25.3766 27.2126L23.2284 30.2387C22.6358 31.0778 22.8086 32.2475 23.6234 32.8579C24.4383 33.4681 25.5741 33.2901 26.1667 32.451L28.315 29.4249C28.9076 28.5858 28.7347 27.4161 27.9199 26.8057Z",
    fill: "#303A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46C35.7025 46 46 35.7025 46 23ZM2 23C2 11.402 11.402 2 23 2C34.598 2 44 11.402 44 23C44 34.598 34.598 44 23 44C11.402 44 2 34.598 2 23Z",
    fill: "#303A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizum);
export default __webpack_public_path__ + "static/media/bizum.fd37909d7839b5671b18dc515b8d4ebb.svg";
export { ForwardRef as ReactComponent };